import { router } from "./Router";
import { QueryClient, QueryClientProvider } from "@tanstack/react-query";
import * as Sentry from "@sentry/react";
import { SENTRY } from "./config.ts";
import { AuthProvider } from "./core/session/providers/AuthProvider";
import { RouterProvider } from "react-router-dom";
import FirebaseProvider from "./utils/firebase/FirebaseProvider";
import { Provider } from "./ui/chakra/provider";
import "./main.module.css";

const queryClient = new QueryClient();
Sentry.init({
  dsn: SENTRY.DSN,
  integrations: [
    Sentry.browserTracingIntegration(),
    Sentry.replayIntegration(),
  ],
  tracesSampleRate: 1.0,
  environment: import.meta.env.MODE,
  replaysSessionSampleRate: 0.1,
  replaysOnErrorSampleRate: 1.0,
  enabled: import.meta.env.PROD,
});
function App() {
  return (
    <QueryClientProvider client={queryClient}>
      <Provider>
        <AuthProvider>
          <FirebaseProvider>
            <RouterProvider router={router} />
          </FirebaseProvider>
        </AuthProvider>
      </Provider>
    </QueryClientProvider>
  );
}

export default App;
